<template>
  <div class="nav-bar">
    <v-app-bar app flat elevate-on-scroll fixed>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="grey--text">
        <!-- <span class="font-weight-light">NotaFiscal</span>
        <span class="font-weight-medium">Avulsa</span>-->
        <img :src="`data:image/png;base64,${logoPrefeitura}`" alt height="50"/>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">
        <v-btn
            small
            text
            v-for="link in links"
            :key="link.text"
            router
            :to="link.route"
        >
          <span>{{ link.text }}</span>
        </v-btn>
      </v-toolbar-items>
<!--      <v-btn-->
<!--          small-->
<!--          outlined-->
<!--          color="primary"-->
<!--          class="mx-2"-->
<!--          route-->
<!--          v-on:click="abrePopUp()">-->
<!--        Cadastro-->
<!--      </v-btn>-->

      <v-menu offset-y class="menu-cadastro" v-if="habilitadoCardCadastro">
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined small color="primary"
                 v-bind="attrs"
                 v-on="on">
            <v-icon small left>mdi-arrow-down</v-icon>
            {{ botaoCardCadastro }}
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
              v-for="(item, index) in opcoesCadastro"
              :key="index">
            <v-list-item-title @click="abrePopUpUrl(item.url)">{{ item.opcao }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn depressed small color="primary" class="mx-2" route :to="linkLogin">
        <v-icon small left>exit_to_app</v-icon>
        {{ botaoCardEntrar }}
      </v-btn>
      <v-btn depressed small color="primary" class="mx-2" route @click="redirecionaPaginaNotaEletronica" v-if="habilitaLinkNotaEletronica">
        Acessar Nota Eletrônica
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer app temporary v-model="drawer" color="primary">
      <v-list>
        <v-list-item v-for="link in linksDrawer" v-show="link.show" :key="link.text" router :to="link.route">
          <v-list-item-icon>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="white--text">{{
              link.text
            }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {base_url} from "../global";

export default {
  name: "Navbar",
  props: {
    logoPrefeitura: {
      type: String,
    },
    habilitaLinkNotaEletronica: {
      type: Boolean,
    },
    habilitadoAutenticacaoPessoaFisica: {
      type: Boolean,
    },
    habilitadoAutenticacaoPessoaJuridica: {
      type: Boolean,
    },
    urlCadastroAvulsaPessoaFisica: {
      type: String,
    },
    urlCadastroAvulsaPessoaJuridica: {
      type: String,
    },
    permiteRedefinicaoEmail: {
      type: Boolean,
    },
    botaoCardCadastro: {
      type: String,
    },
    botaoCardEntrar: {
      type: String,
    },
    habilitadoCardPrimeiroAcesso: {
      type: Boolean,
    },
    habilitadoCardCadastro: {
      type: Boolean,
    },
  },
  data() {
    return {
      opcoesCadastro: [],
      drawer: false,
      linkLogin: "/login",
      linkNotaEletronica: window.location.origin.concat("/notafiscal/paginas/portal"),
      // linkCredenciamento: "/credenciamento",
      linkCredenciamento: `${base_url}/notafiscal/paginas/contribuintefora/contribuinteForaList.jsf?faces-redirect=true&incluir=S`,
      linksDrawer: [
        {icon: "home", text: "Inicial", show: true, route: "/"},
        {icon: "done_all", text: "Autenticidade", show: true, route: "/autenticidade"},
        {icon: "account_circle", text: "Entrar", show: true, route: "/login"},
        { icon: "lock", text: "Recuperar senha", show: this.habilitadoCardPrimeiroAcesso, route: {name: "SolicitarSenha", params: { cpf: this.habilitadoAutenticacaoPessoaFisica, cnpj: this.habilitadoAutenticacaoPessoaJuridica}} },
        // {icon: "history", text: "Recuperar Email", route: "/recuperarEmail"},
        // {
        //   icon: "recent_actors",
        //   text: "Cadastro",
        //   route: "/credenciamento",
        // },
        {icon: "folder", text: "Legislação", show: true, route: "/legislacao"},
        {icon: "live_help", text: "Ajuda", show: true, route: "/ajuda"},
        {icon: "question_answer", text: "Fale Conosco", show: true, route: "/contato"},
      ],
      links: [
        {icon: "home", text: "Inicial", route: "/"},
        {icon: "done_all", text: "Autenticidade", route: "/autenticidade"},
        {icon: "folder", text: "Legislação", route: "/legislacao"},
        {icon: "live_help", text: "Ajuda", route: "/ajuda"},
        {icon: "question_answer", text: "Fale Conosco", route: "/contato"},
      ],
    };
  },
  methods: {
    redirecionaPaginaNotaEletronica() {
      window.location.href = this.linkNotaEletronica;
    },
    abrePopUp() {
      let url = this.habilitadoAutenticacaoPessoaFisica ? this.urlCadastroAvulsaPessoaFisica : this.urlCadastroAvulsaPessoaJuridica;
      this.abrePopUpUrl(url)
    },
    abrePopUpUrl(url) {
      window.open(url, 'Pagina', 'resizable=0,WIDTH=1024, HEIGHT=640')
    }
  },
  mounted() {
    this.opcoesCadastro.push({"opcao": "Pessoa Física", "url": this.urlCadastroAvulsaPessoaFisica});
    this.opcoesCadastro.push({"opcao": "Pessoa Jurídica", "url": this.urlCadastroAvulsaPessoaJuridica});

    if (!this.permiteRedefinicaoEmail)
      this.linksDrawer = this.linksDrawer.filter(l => l['route'] !== "/recuperarEmail")

  },
};
</script>

<style scoped></style>
